import { images } from "../../assets/Images/assetsImages";

const HeroSection = () => {
    return (
      <section className="relative w-full h-[800px]">
        <div className="absolute inset-0 bg-[#E6F3CD] bg-opacity-80 flex items-center justify-center">
          <div className="w-[80%] lg:w-[60%] flex flex-col justify-center mt-[100px] lg:px-[10%]">
            <h1 className="text-[60px] xs:text-[50px] sm:text-[80px] xl:text-[60px] font-bold font-playfair text-[#41220E] text-center lg:text-start">CATERING</h1>
            <p className="xs:text-[20px] text-[25px] xl:text-[20px] font-medium font-montserrat text-[#41220E] text-center lg:text-start mt-8">
                Elevate your next event with Symphonys Artisanal Bakery Catering. From grand celebrations to intimate gatherings, our handcrafted delights will impress your guests.
            </p>
          </div>
          <div className="hidden lg:flex w-[35%] h-full items-end">
            <div className="w-full h-[80%]">
                <img src={images.LogoBackground} alt="LogoBackground" className="w-full h-full opacity-20"></img>
            </div>
          </div>
        </div>
      </section>
    );
  };
  
  export default HeroSection;
  